import React from 'react'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import FastfoodIcon from '@material-ui/icons/Fastfood';
import EmojiEmotionsIcon from '@material-ui/icons/EmojiEmotions';

export const WellMeal = React.forwardRef((props, ref) => {

    const data = [
        {
            name: 'January',
            PreCovid: 61.3,
            PostCovid: 51.8,
            amt: 100,
        },
        {
            name: 'February',
            PreCovid: 64.4,
            PostCovid: 49.8,
            amt: 100,
        },
        {
            name: 'March',
            PreCovid: 67.8,
            PostCovid: 45.6,
            amt: 100,
        },
        {
            name: 'April',
            PreCovid: 71.9,
            PostCovid: 42.1,
            amt: 100,
        },
        {
            name: 'May',
            PreCovid: 69.23,
            PostCovid: 39.3,
            amt: 100,
        },
        {
            name: 'June',
            PreCovid: 71.4,
            PostCovid: 42.2,
            amt: 100,
        },
        {
            name: 'July',
            PreCovid: 70.9,
            PostCovid: 48.1,
            amt: 100,
        },
        {
            name: 'August',
            PreCovid: 80.9,
            PostCovid: 32.1,
            amt: 100,
        },
        {
            name: 'September',
            PreCovid: 72.9,
            PostCovid: 37.7,
            amt: 100,
        },
        {
            name: 'October',
            PreCovid: 67.1,
            PostCovid: 31.6,
            amt: 100,
        },
        {
            name: 'November',
            PreCovid: 81.8,
            PostCovid: 32.9,
            amt: 100,
        },
        {
            name: 'December',
            PreCovid: 83.13,
            PostCovid: 30.1,
            amt: 100,
        },
    ];
    return (
        <>
            <div className="app-info-container" ref = {ref}>
                <div className="info-hero">
                    <div className="hero-graph">
                        <h5> Percentage of individuals who are happy and entertained during their meal </h5>
                        <ResponsiveContainer width="100%" height="100%">
                            <LineChart
                                width={500}
                                height={300}
                                data={data}
                                margin={{
                                    top: 5,
                                    right: 50,
                                    left: 20,
                                    bottom: 5,
                                }}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="name" />
                                <YAxis />
                                <Tooltip />
                                <Legend />
                                <Line type="monotone" dataKey="PreCovid" stroke="#8884d8" activeDot={{ r: 8 }} />
                                <Line type="monotone" dataKey="PostCovid" stroke="#82ca9d" />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </div>
                <div className="info-text">
                    <div className="info-header">
                        <h1> Foodies believes the power of food with the power of friendship is the formula to high quality life. </h1>
                        <p> Your happiness depends on having the perfect meal that you want with perfect people. We aim to reduce your concerns and save your time by providing you the best meal choices based on your mood in the day and network you with unique and similar-minded individuals. </p>
                    </div>
                    <div className="info-sections">
                        <SupervisedUserCircleIcon style={{ fontSize: 50, color: 'rgb(103, 189, 114)', border: '3px solid green', borderRadius: '100%' }} />
                        <div className="section-text">
                            <h3> Unique Matching Between Users  </h3>
                            <p> Foodies has a matching system based on each user's food interests, their location and age for users to network with similar individuals and also to suggest restaurants considering their location and food interests so that they can visit.</p>
                        </div>

                    </div>
                    <div className="info-sections">
                        <FastfoodIcon style={{ fontSize: 50, color: 'rgb(103, 189, 114)', border: '3px solid green', borderRadius: '100%' }} />
                        <div className="section-text">
                            <h3> Specific and Diverse Choices of recipes </h3>
                            <p> With thousands of API datas, Foodies' recipe generator takes in diverse inputs to satisfy user's meal choices for the day. From a balanced American breakfast to high caloorie chinese lunch course, we got it all!</p>
                        </div>

                    </div>
                    <div className="info-sections">
                        <EmojiEmotionsIcon style={{ fontSize: 50, color: 'rgb(103, 189, 114)', border: '3px solid green', borderRadius: '100%' }} />
                        <div className="section-text">
                            <h3> Food + Networking that will bring happiness </h3>
                            <p> By having 2 features on the website, we allow food to combine with networking. With Covid-19's side effect, people were restricted from discovering new food choices and having an entertained meal with someone they love, like or trust. Foodies will open that door for you. </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
})
